module.exports = __webpack_public_path__ + "img/iva_invoiceweb.6a1c8727.png";